<template>
    <div class="accordion">
        <div class="accordion__container--blur"></div>
        <AccordionTitle v-if="!header" :title="title" :id="id" :open="open" :index="index" :iconUrl="iconUrl"
            @toggle="onToggle" @delete="onPopDelete" />
        <AccordionContent :open="open">
            <slot></slot>
        </AccordionContent>

        <Popup ref="deletePopUp" size="sm-mod2">
            <div class="text-center">
                <h1 class="text-center title-pop-child">Eliminar {{
                    title.toLowerCase().includes('auto') ? 'auto' :
                    title.toLowerCase().includes('hij') ? 'hij@' : ''
                }}</h1>


                <mdb-row>
                    <mdb-col md="1" style="margin-bottom: 10px;"></mdb-col>
                    <mdb-col md="10" style="margin-bottom: 10px;">
                        <p class="text-pop-delete">

                            <span style="font-weight: 600;">Al realizar la eliminación del formulario de tu {{
                                title.toLowerCase().includes('auto') ? 'auto' :
                                title.toLowerCase().includes('hij') ? 'hij@' : ''
                            }},
                                deberás añadirlo nuevamente e ingresar la información que solicita. ¿Desea
                                continuar?</span>
                        </p>
                    </mdb-col>
                    <mdb-col md="1" style="margin-bottom: 10px;"></mdb-col>
                </mdb-row>

                <mdb-row>
                    <mdb-col md="3" style="margin-bottom: 10px;"></mdb-col>

                    <mdb-col md="3" style="margin-bottom: 10px;">
                        <btn type="ghost" text="Cancelar" @onClick="cancelDelete" />
                    </mdb-col>

                    <mdb-col md="3" style="margin-bottom: 10px;">
                        <btn type="primary-block" text="Continuar" @onClick="proceedDelete" />
                    </mdb-col>

                    <mdb-col md="3" style="margin-bottom: 10px;"></mdb-col>
                </mdb-row>
            </div>
        </Popup>
    </div>
</template>
<script>
import AccordionTitle from "../core/Accordion/Title";
import AccordionContent from "../core/Accordion/Content";
import { mdbRow, mdbCol } from "mdbvue";
import Popup from "../core/Popup";
import Btn from "../core/Button";

export default {
    props: ["header", "title", "id", "index", "eventHub"],
    name: "Accordion",
    components: {
        AccordionTitle,
        AccordionContent,
        mdbRow,
        mdbCol,
        Popup,
        Btn
    },
    data() {
        return {
            open: false,
            iconUrl: "/img/icons/borrar-default.svg",
            deleteDefault: "/img/icons/borrar-default.svg",
            deleteClick: "/img/icons/borrar-click.svg"
        }
    },
    methods: {
        onToggle() {
            this.open = !this.open;
            if (this.id == 'titular') {
                this.$store.commit("setTitular", this.open)
            }
            if (this.id == 'conyuge') {
                this.$store.commit("setConyuge", this.open)
            }
            if (this.id == 'beneficiarios') {
                this.$store.commit("setBeneficiaries", this.open)
            }
        },
        onPopDelete() {
            this.iconUrl = this.deleteClick;
            this.$refs.deletePopUp.toggleModal()
        },
        onDelete() {
            this.$emit("delete", this.index);
        },
        cancelDelete() {
            this.iconUrl = this.deleteDefault;
            this.$refs.deletePopUp.toggleModal()
        },
        proceedDelete() {
            this.iconUrl = this.deleteDefault;
            this.$refs.deletePopUp.toggleModal()
            this.$emit('delete', this.index)
        },
        closeAll() {
            this.open = false;
            this.$store.commit("setTitular", this.open)
            this.$store.commit("setConyuge", this.open)
            this.$store.commit("setBeneficiaries", this.open)
        }
    },
    mounted() {
        if (this.header == "off") {
            this.onToggle();
        }
    },
    created() {
        this.eventHub.$on('closeall', this.closeAll);
    },
    beforeDestroy() {
        this.eventHub.$off('closeall', this.closeAll)
    },
}
</script>